export const errorImage = 'https://ak4.picdn.net/shutterstock/videos/260119/thumb/1.jpg'